<div id="modal-content-wrapper">
  <div mat-dialog-content class="body">
    <p>
      {{ 'easy-trade.modal.add-first-company.message' | translate : data.companyName }}
    </p>
  </div>
  <mat-divider></mat-divider>
  <button class="close" (click)="closeDialog()">
    <mat-icon>Ok</mat-icon>
  </button>
</div>
